<template>
  <div>
    <!-- <topnav /> -->
    <div class="show-container">
      <div class="show-title">
        <button class="hollow-btn" @click="$router.go(-1)" style="margin-right: 40px;">返回</button>
        <span>图片序号：{{ $route.query.orderNumber }}</span>
        <span>图片状态：{{ imageStatusMap[imageStatus] }}</span>
      </div>
      <AnnoPanel
        :src="url"
        ref="annopanel"
        :annos="annos"
        height="646"
        :style="{ height: '646px', background: '#fafafa' }"
        :mode="mode"
        scalable
        maskColor="blue"
      ></AnnoPanel>
      <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
        <span>沪ICP备20000777号-1</span>
      </a>
    </div>
  </div>
</template>

<script>
import AnnoPanel from '@/components/AnnoPanel.vue';
// import topnav from '@/components/topnav';
import * as api from '@/api/api.js';
import { imageStatusMapCustomer, taskTypeMap } from '@/config';

export default {
  data: function() {
    return {
      searchImageId: null,
      imageStatusMap: [],
      imageId: 0,
      url: '',
      imageStatus: 0,
      taskTypeName: '',
      annotations: [],
      annos: [],
      mode: 1,
    };
  },
  components: {
    AnnoPanel,
    // topnav,
  },
  mounted: function() {
    this.imageStatusMap = imageStatusMapCustomer;
    this.getImageInfo();
  },
  methods: {
    searchImage() {
      if (this.searchImageId > 0 && this.searchImageId != this.imageId) {
        api
          .getImageInfo({ id: this.$route.params.id, imageid: this.searchImageId })
          .then(res => {
            if (res.data.id) {
              this.$router.push({ path: `/task/${this.$route.params.id}/image/${this.searchImageId}` });
              this.$router.go(0);
            }
          })
          .catch(() => {
            this.searchImageId = null;
          });
      }
    },
    getImageInfo() {
      api
        .getImageInfo(this.$route.params)
        .then(res => {
          this.imageId = res.data.id;
          this.url = res.data.url;
          this.imageStatus = res.data.imageStatus;
          this.taskTypeName = res.data.taskTypeName;
          this.annotations = res.data.annotations;
          this.annos = this.annotations.map(anno => {
            return {
              id: anno.id,
              type: taskTypeMap[this.taskTypeName],
              cat: anno.classes[0].classId,
              title: anno.classes.map(item => item.className).join(','),
              data: anno.points,
            };
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
input {
  box-sizing: border-box;
  height: 38px;
  margin-left: 6px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  font-size: 14px;
  padding: 0px 12px;
}
.show-container {
  padding: 0px 50px 24px;
  width: 100%;
  box-sizing: border-box;
}
.show-title {
  margin: 24px 0px;
  font-size: 14px;
  position: relative;
}
.show-title span {
  font-size: 18px;
  margin-right: 100px;
}
.show-title button {
  height: 38px;
  width: 65px;
  margin: 0px;
  margin-left: 18px;
}
.show-title div {
  position: absolute;
  right: 0px;
  bottom: 0px;
  display: inline-block;
}
.icp-info {
  display: block;
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
</style>
